import { render, staticRenderFns } from "./FormProdutoPagina.vue?vue&type=template&id=7003474e"
import script from "./FormProdutoPagina.vue?vue&type=script&lang=ts"
export * from "./FormProdutoPagina.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports